export default __webpack_public_path__ + "static/media/Brandon_med.6c7d60fa.otf";